export const BORG_ENDPOINT = 'https://autocomplete.toolfactory.tech/query';
export const MIN_ITEMS_TO_SHOW = 3;
export const DEBOUNCE_DELAY = 300;
export const HEADER_ICON = {
    AER: 'plane',
    BUS: 'bus',
    CIU: 'building',
    EST: 'train',
    FLIGHTS_COMPANY: 'plane',
    HOT: 'hotel',
    ISL: 'beach',
    PDI: 'marker',
    PUE: 'ferry',
    ZON: 'marker',
    PAI: '',
    ACT: 'ticket'
};
export const autocompleteLiterals = {
    es: {
        bus: 'bus',
        BUS: 'bus',
        airport: 'aeropuerto',
        AER: 'aeropuerto',
        airports: 'aeropuertos',
        island: 'isla',
        ISL: 'isla',
        islands: 'islas',
        zone: 'zona',
        ZON: 'zona',
        zones: 'zonas',
        station: 'estación',
        EST: 'estación',
        stations: 'estaciones',
        hotel: 'hotel',
        HOT: 'hotel',
        hotels: 'hoteles',
        city: 'ciudad',
        CIU: 'ciudad',
        cities: 'ciudades',
        pdi: 'pdi',
        PDI: 'pdi',
        port: 'puerto',
        PUE: 'puerto',
        ports: 'puertos',
        flightCompanies: 'compañía aérea',
        FLIGHTS_COMPANY: 'compañía aérea',
        PAI: 'País',
        country: 'País',
        ACT: 'actividad'
    },
    pt: {
        bus: 'autocarro',
        BUS: 'autocarro',
        airport: 'aeroporto',
        AER: 'aeroporto',
        airports: 'aeroportos',
        island: 'ilha',
        ISL: 'ilha',
        islands: 'ilhas',
        zone: 'zona',
        ZON: 'zona',
        zones: 'zonas',
        station: 'estação',
        EST: 'estação',
        stations: 'estâncias',
        hotel: 'hotel',
        HOT: 'hotel',
        hotels: 'hotéis',
        city: 'cidade',
        CIU: 'cidade',
        cities: 'cidades',
        pdi: 'pdi',
        PDI: 'pdi',
        port: 'porto',
        PUE: 'porto',
        ports: 'portos',
        flightCompanies: 'flight_company',
        FLIGHTS_COMPANY: 'flight_company',
        PAI: 'País',
        country: 'País',
        ACT: 'atividade'
    },
    it: {
        bus: 'autobus',
        BUS: 'autobus',
        airport: 'aeroporto',
        AER: 'aeroporto',
        airports: 'aeroporti',
        island: 'isola',
        ISL: 'isola',
        islands: 'isole',
        zone: 'zona',
        ZON: 'zona',
        zones: 'zone',
        station: 'stazione',
        EST: 'stazione',
        stations: 'stazioni',
        hotel: 'hotel',
        HOT: 'hotel',
        hotels: 'hotel',
        city: 'città',
        CIU: 'città',
        cities: 'città',
        pdi: 'pdi',
        PDI: 'pdi',
        port: 'porto',
        PUE: 'porto',
        ports: 'porti',
        flightCompanies: 'flight_company',
        FLIGHTS_COMPANY: 'flight_company',
        PAI: 'Paese',
        country: 'Paese',
        ACT: 'attività'
    },
    de: {
        bus: 'bus',
        BUS: 'bus',
        airport: 'flughafen',
        AER: 'flughafen',
        airports: 'flughäfen',
        island: 'insel',
        ISL: 'insel',
        islands: 'inseln',
        zone: 'reiseziel',
        ZON: 'reiseziel',
        zones: 'zielgebiete',
        station: 'station',
        EST: 'station',
        stations: 'stationen',
        hotel: 'hotel',
        HOT: 'hotel',
        hotels: 'hotels',
        city: 'stadte',
        CIU: 'stadte',
        cities: 'städte',
        pdi: 'pdi',
        PDI: 'pdi',
        port: 'hafen',
        PUE: 'hafen',
        ports: 'häfen',
        flightCompanies: 'flight_company',
        FLIGHTS_COMPANY: 'flight_company',
        PAI: 'Land',
        country: 'Land',
        ACT: 'aktivität'
    },
    fr: {
        bus: 'bus',
        BUS: 'bus',
        airport: 'aéroport',
        AER: 'aéroport',
        airports: 'aéroports',
        island: 'île',
        ISL: 'île',
        islands: 'îles',
        zone: 'zone',
        ZON: 'zone',
        zones: 'zones',
        station: 'station',
        EST: 'station',
        stations: 'stations',
        hotel: 'hôtel',
        HOT: 'hôtel',
        hotels: 'hôtels',
        city: 'ville',
        CIU: 'ville',
        cities: 'villes',
        pdi: 'pdi',
        PDI: 'pdi',
        port: 'port',
        PUE: 'port',
        ports: 'ports',
        flightCompanies: 'flight_company',
        FLIGHTS_COMPANY: 'flight_company',
        PAI: 'Pays',
        country: 'Pays',
        ACT: 'activité'
    },
    br: {
        bus: 'ônibus',
        BUS: 'ônibus',
        airport: 'aeroporto',
        AER: 'aeroporto',
        airports: 'aeroportos',
        island: 'ilha',
        ISL: 'ilha',
        islands: 'ilhas',
        zone: 'zona',
        ZON: 'zona',
        zones: 'zonas',
        station: 'estação',
        EST: 'estação',
        stations: 'estâncias',
        hotel: 'hotel',
        HOT: 'hotel',
        hotels: 'hotéis',
        city: 'cidade',
        CIU: 'cidade',
        cities: 'cidades',
        pdi: 'pdi',
        PDI: 'pdi',
        port: 'porto',
        PUE: 'porto',
        ports: 'portos',
        flightCompanies: 'flight_company',
        FLIGHTS_COMPANY: 'flight_company',
        PAI: 'País',
        country: 'País',
        ACT: 'atividade'
    },
    en: {
        bus: 'bus',
        BUS: 'bus',
        airport: 'airport',
        AER: 'airport',
        airports: 'airports',
        island: 'island',
        ISL: 'island',
        islands: 'islands',
        zone: 'zone',
        ZON: 'zone',
        zones: 'zones',
        station: 'station',
        EST: 'station',
        stations: 'stations',
        hotel: 'hotel',
        HOT: 'hotel',
        hotels: 'hotels',
        city: 'city',
        CIU: 'city',
        cities: 'cities',
        pdi: 'poi',
        PDI: 'poi',
        port: 'port',
        PUE: 'port',
        ports: 'ports',
        flightCompanies: 'flight_company',
        FLIGHTS_COMPANY: 'flight_company',
        PAI: 'Country',
        country: 'Country',
        ACT: 'activity'
    },
    fi: {
        bus: 'bussi',
        BUS: 'bussi',
        airport: 'lentokenttä',
        AER: 'lentokenttä',
        airports: 'lentokentille',
        island: 'saari',
        ISL: 'saari',
        islands: 'saaret ',
        zone: 'vyöhyke',
        ZON: 'vyöhyke',
        zones: 'alueet',
        station: 'kausi',
        EST: 'kausi',
        stations: 'asemat',
        hotel: 'hotelli',
        HOT: 'hotelli',
        hotels: 'hotellit',
        city: 'kaupunki',
        CIU: 'kaupunki',
        cities: 'kaupungit',
        pdi: '',
        PDI: '',
        port: 'portti',
        PUE: 'portti',
        ports: 'satamat',
        flightCompanies: 'flight_company',
        FLIGHTS_COMPANY: 'flight_company',
        PAI: 'Maa',
        country: 'Maa',
        ACT: 'toiminta'
    },
    mx: {
        bus: 'bus',
        BUS: 'bus',
        airport: 'aeropuerto',
        AER: 'aeropuerto',
        airports: 'aeropuertos',
        island: 'isla',
        ISL: 'isla',
        islands: 'islas',
        zone: 'zona',
        ZON: 'zona',
        zones: 'zonas',
        station: 'estación',
        EST: 'estación',
        stations: 'estaciones',
        hotel: 'hotel',
        HOT: 'hotel',
        hotels: 'hoteles',
        city: 'ciudad',
        CIU: 'ciudad',
        cities: 'ciudades',
        pdi: 'pdi',
        PDI: 'pdi',
        port: 'puerto',
        PUE: 'puerto',
        ports: 'puertos',
        flightCompanies: 'flight_company',
        FLIGHTS_COMPANY: 'flight_company',
        PAI: 'País',
        country: 'País',
        ACT: 'actividad'
    },
    ru: {
        bus: 'bus',
        BUS: 'bus',
        airport: 'aэропорт',
        AER: 'aэропорт',
        airports: 'аэропорты',
        island: 'oстрова',
        ISL: 'oстрова',
        islands: 'oстрова',
        zone: 'Зона',
        ZON: 'Зона',
        zones: 'Зоны',
        station: 'станцию',
        EST: 'станцию',
        stations: 'станции',
        hotel: 'отель',
        HOT: 'отель',
        hotels: 'oтели',
        city: 'город',
        CIU: 'город',
        cities: 'Города',
        pdi: 'Достопримечательности',
        PDI: 'Достопримечательности',
        port: 'порт',
        PUE: 'порт',
        ports: 'Порты',
        flightCompanies: 'flight_company',
        FLIGHTS_COMPANY: 'flight_company',
        PAI: 'Страна',
        country: 'Страна',
        ACT: 'активность'
    }
};

//# sourceMappingURL=autocomplete.js.map